import * as React from 'react';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useUserName from 'flow-doctor-lib/hooks/useUserName';
import { jsx as _jsx } from "react/jsx-runtime";
const UserNameLabel = ({
  userId
}) => {
  const {
    loading,
    error,
    data: fullUserName
  } = useUserName({
    userId
  });
  if (error) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.references.user.unknownUser"
      })
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return /*#__PURE__*/_jsx("span", {
    children: fullUserName
  });
};
export default UserNameLabel;